import React from "react";

// reactstrap components
import {
  Form,
  FormGroup,
  Input,
  Label,
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  CardFooter,
  Row,
  Col,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  UncontrolledTooltip,
  InputGroupAddon,
  InputGroup,
  Container,
} from "reactstrap";

import {
  PanelHeader, 
  Button,
  // CardCategory
} from "components";



function BusinessPartnerForm(props) {
    const { 
            descriptionState, description, 
            whyPartnerState, whyPartner,
             } = props 

    const { submitted, isBot, botChecked } = props 

    const { 
             checkDescription, checkWhyPartner, handleSubmit, 
             } = props 

  return (
    <>
     <Row className='mt-4'>
        <Col lg="12" >
            <Label className="form-control-label surtitle-light-gray">About you
            <i className="pl-2 fas fa-info-circle surtitle-light-gray cursor-pointer " 
                    id="description"
                />
                <UncontrolledTooltip  
                placement="right" 
                target="description" 
                delay={0}> 
                Write a blurb about yourself. Try to keep it concise. 
                </UncontrolledTooltip>

            </Label>
            <FormGroup className={"mt-2 " + descriptionState}>
                <Input 
                type="textarea" 
                name="description"
                className='bg-transparent surtitle-light-gray'
                value={description}
                placeholder="Write a blurb about yourself. Tell us what you want us to know about you, but try to keep it concise.
                If you have other links showcasing your work on other platforms (ex: Apple Music, Spotify, Soundcloud), you can include them here. "
                rows="12"
                cols="80"
                style={{maxHeight:"300px"}}
                onChange={e => checkDescription(e)}
                valid={
                    descriptionState === "has-success"
                }
                invalid={
                    descriptionState === "has-danger"
                }  />
            </FormGroup>
            </Col>

            <Col lg="12" >
            <Label className="form-control-label surtitle-light-gray">Why do you want to parner with us? 
            <i className="pl-2 fas fa-info-circle surtitle-light-gray cursor-pointer " 
                    id="whyPartner"
                />
                <UncontrolledTooltip  
                placement="right" 
                target="whyPartner" 
                delay={0}> 
                Let us know why you want to partner with us.  
                </UncontrolledTooltip>

            </Label>
            <FormGroup className={"mt-2 " + whyPartnerState}>
                <Input 
                type="textarea" 
                name="whyPartner"
                value={whyPartner}
                className='bg-transparent surtitle-light-gray'
                placeholder="Why do you want to partner with us?"
                rows="12"
                cols="80"
                style={{maxHeight:"300px"}}
                onChange={e => checkWhyPartner(e)}
                valid={
                    whyPartnerState === "has-success"
                }
                invalid={
                    whyPartnerState === "has-danger"
                }  />
            </FormGroup>
            </Col>
            <Col xs={12} className="text-center">
            <Button style={{fontSize:"1rem"}} disabled={submitted || isBot || !botChecked} color="white" size="lg" block className="title" onClick={e => handleSubmit(e)}>
                {submitted ? 'Application sent' : 'Apply'}
            </Button>
            </Col>
    </Row>
    </>
  );
}

export default BusinessPartnerForm;
